import { Close } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton } from '@mui/material';
import * as React from 'react';
import { VdsTextField } from '..';
import { escapeHtmlEntities } from '../../../utilities/formUtils';
import { Filters, VdsTableProps } from './VdsTable';

/** Traduzioni di default per le sezioni della tabella */
const tsl = {
    searchPlaceholder: 'Find'
}

/** Stili di default per le sezioni della tabella */
const searchIconStyle = {
    p: '8px',
    color: 'white',
    borderRadius: '0!important',
    backgroundImage: 'linear-gradient(90deg, #0090D1, #00C3EA)'
};
const resetIconStyle = {
    padding: 0,
    opacity: 0.3
};
const searchTextFieldStyle = {
    width: '410px'
};

/** Riferimento statico per l'esposizione di metodi interni al campo di ricerca */
type VdsSearchReference = React.ForwardedRef<{ search: string; }>;

// Proprietà applicabili al campo di ricerca con riferimento
interface SearchFieldProps {
    search?: string;            // Valore iniziale del campo di ricerca
    placeholder?: string;       // Traduzione realativa al placeholder
    submit: (filters: Partial<Filters>) => void;     // Evento di applicazione del filtro
}

// Componente referenziato per la gesione dello stato del campo di ricerca
const SearchField: (props: SearchFieldProps) => React.ReactElement = (props) => {

    const [tempSearch, setTempSearch] = React.useState<string>(props?.search || '');
    const [search, setSearch] = React.useState<string>(props?.search || '');

    React.useEffect(() => {

        setTempSearch(props?.search || '');
        setSearch(props?.search || '');

    }, [props?.search]);

    const resetFilter = () => {

        setSearch('');
        setTempSearch('');
        props.submit({ search: '' });
    }

    const applyFilter = () => {

        setSearch(tempSearch);
        props.submit({ search: tempSearch });
    };

    const onKeyPressEventHandler = (event: any) => {

        if (event.key === 'Enter') {

            setSearch(tempSearch);
            props.submit({ search: tempSearch });
        }
    };

    return (
        <React.Fragment>
            <VdsTextField
                onChange={(ev) => {

                    setTempSearch(ev.target.value);
                }}
                placeholder={props?.placeholder || tsl.searchPlaceholder}
                size="small"
                value={escapeHtmlEntities(tempSearch)}
                onKeyPress={onKeyPressEventHandler}
                onBlur={(ev) => {

                    if ((ev.relatedTarget as any)?.dataset?.targetId !== "search-field-button") {

                        setTempSearch(search);
                    }
                }}
                endAdornment={search && (
                    <IconButton
                        data-target-id="search-field-button"
                        sx={resetIconStyle}
                        onClick={resetFilter}
                        style={{ cursor: 'pointer !important', opacity: 'unset' }}
                    >
                        <Close style={{ cursor: 'pointer !important', fill: '#0090D1', fontSize: '23px' }} />
                    </IconButton>
                )}
                sx={searchTextFieldStyle}
                collapse
            />
            <IconButton
                data-target-id="search-field-button"
                sx={searchIconStyle}
                onClick={applyFilter}
            >
                <SearchIcon />
            </IconButton>
        </React.Fragment>
    );
}

type ConditionalSearchFieldProps<R> =
    { useSearch: false; } |
    { ref?: VdsSearchReference; useSearch: true; } & SearchFieldProps & { options: VdsTableProps<R>['options']  }

export const ConditionalSearchField: <R>(props: ConditionalSearchFieldProps<R>) => React.ReactElement = (props) => {

    if (props.useSearch === false) return null;

    const { search, submit, placeholder } = props;

    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', minWidth: props.options?.minWidth || 'auto' }}>

            <SearchField
                search={search}
                submit={submit}
                placeholder={placeholder}
            />
        </Box>
    );
}
